<template>
    <div>
        <div class="formula-title">
            <span class="f-row-sp-center">
                公式配置
                <el-tooltip
                    content="1、使用@符号可选择函数；2、鼠标点到公式指定内容位置，左侧指标可通过拖拽添加到该位置；3、公式要符合常规数学运算，避免其他违规字符！"
                    placement="top"
                >
                    <el-icon :size="16"><InfoFilled /></el-icon>
                </el-tooltip>
            </span>

            <div class="f-row-sp-center">
                <el-button @click="handleClear" size="small">
                    清空
                </el-button>
                <el-button @click="handleClickMatching" size="small" type="danger">
                    自动匹配
                </el-button>
                <el-tooltip
                    content="文本内容与函数或指标名称一致可进行自动匹配；例如：abs()会自动匹配上绝对值函数"
                    placement="top"
                >
                    <el-icon :size="16"><QuestionFilled /></el-icon>
                </el-tooltip>
            </div>
        </div>
        <div @drop="drop" @dragover.prevent class="do-flex">
            <Formula ref="formulaComponent" :variableList="_variableList" :functionList="functionList"></Formula>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, reactive } from 'vue';
import Formula from './formula.vue';
import formulaUtil from './gongchangformulautil';
import { ElMessage } from 'element-plus';
import { ABS_SYMBOL } from '@/option/common/dict';
import { QuestionFilled, InfoFilled } from "@element-plus/icons-vue";
import { funNameList, zkFun } from '@/utils/formulaFunc' 

const formulaComponent = ref(null);
const copyRow = reactive({});
const drop = e => {
    let item = JSON.parse(e.dataTransfer.getData('drag-info'));
    formulaComponent.value.handleAddVar({
        id: item.id || Date.now(),
        type: item.fieldType !== 'pageParams' ? formulaUtil.Const.xm.value : 'pageParams',
        key: item.code,
        value: item.name
    });
};
const emit = defineEmits(['saveCallBack']);
let props = defineProps({
    initData: {
        type: Array,
        default: () => []
    },
    variableList: {
        type: Array,
        default: () => []
    }
    // initData: ()=> []
});

const functionList = reactive(funNameList)
const selectItemArray = ref([]);
const _getRandomValue = () => {
    var baseNum = 231;
    var random = Math.random();
    return (baseNum + random).toFixed(6);
};
// 变量列表
const _variableList = computed(() => {
    const metricList = props.variableList[0].children.map(v => ({
        id: v.id || Date.now(),
        type: formulaUtil.Const.xm.value,
        key: v.code,
        value: v.name
    }));
    const pageList = props.variableList[1].children.map(v => ({
        id: v.id || Date.now(),
        type: 'pageParams',
        key: v.code,
        value: v.name
    }));
    return [...metricList, ...pageList];
});
// 校验合法性
const checkValid = str => {
    let res;
    try {
        if (str.indexOf(ABS_SYMBOL.ABS_LEFT) >= 0 || str.indexOf(ABS_SYMBOL.ABS_RIGHT) >= 0) {
            res = eval(
                str
                    .replaceAll(ABS_SYMBOL.ABS_LEFT, 'Math.abs(')
                    .replaceAll(ABS_SYMBOL.ABS_RIGHT, ')')
            );
        } else {
            res = eval(str);
        }
        if (res == Infinity) {
            return false;
        }
        if (res == null) {
            return true;
        }
        if (typeof res != 'number') {
            return false;
        }
        res = parseFloat(res);
        return !isNaN(res);
    } catch (exp) {
        return false;
    }
};
// 保存
const handleSave = () => {
    selectItemArray.value = formulaComponent.value.getValueList();
    let jsstr = '';
    selectItemArray.value.map(item => {
        if ([String(formulaUtil.Const.xm.value), 'pageParams'].includes(String(item.type))) {
            jsstr += _getRandomValue();
        } else {
            jsstr += item?.key || item?.value;
        }
    });
    if (jsstr == '') {
        copyRow.formulaView = '';
        copyRow.formula = '';
        copyRow.formulaData = [];
        emit('saveCallBack', copyRow);
        return true;
    } else if (checkValid(jsstr)) {
        copyRow.formulaView = formulaUtil.toStr(selectItemArray.value);
        copyRow.formula = formulaUtil.arrayToDisplayScript(selectItemArray.value);
        copyRow.formulaData = selectItemArray.value;
        emit('saveCallBack', copyRow);
        return true;
    } else {
        ElMessage.warning('公式配置格式不正确');
        return false;
    }
};
// 自动匹配
const handleClickMatching = () => {
    formulaComponent.value.matchingFormula();
};
// 清空
const handleClear = () => {
    formulaComponent.value.setFormula([]);
}

onMounted(() => {
    if (props.initData.length) {
        const data = props.initData.map(v => {
            // 兼容old公式配置
            const fun_or_var = ['4', '6'].includes(String(v.type));
            if (fun_or_var && !Reflect.has(v, 'nodeType')) {
                return {
                    ...v,
                    nodeType: v.type == 4 ? 'variable' : 'function'
                };
            }
            return v;
        });
        formulaComponent.value.setFormula(data);
    }
});

defineExpose({
    handleSave
});
</script>
<style lang="scss" scoped>
.f-row-sp-end {
    display: flex;
    flex-direction: row;
    align-items: space-between;
    justify-content: flex-end;
    flex-wrap: nowrap;
}
.f-row-sp-center {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
}
.f-row-btn {
    height: 32px;
    margin-left: 1px;
}
.formula-title {
    font-size: 14px;
    font-weight: 900;
    margin-bottom: 18px;
    // color: #a3a6ad;
    display: flex;
    justify-content: space-between;
}

.func-list {
    display: flex;
    align-items: center;
    margin-top: 16px;
    .func-label {
        color: #a3a6ad;
    }
}
</style>
